export const PermissionsStates = {
    DELETE: 'Permissions_DELETE',
    EXPIRE: 'Permissions_EXPIRE',
    SUCCESS: 'Permissions_SUCCESS',
    FAILED: 'Permissions_FAILED',
    RESET: 'Permissions_RESET',
};
